import React from 'react';
import styled from 'styled-components';
import Link from 'gatsby-link'

import Icon from '../../assets/logo/icon.svg';

const HeaderContainer = styled.div`
  padding: 16px 20px;
  background-color: #202F4E;
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  ${props => props.notFull ? null : 'flex: 1;'}
  ${props => 
    props.position === 'middle' ? 'justify-content: center;' :
    props.position === 'end' ? 'justify-content: flex-end;' : null
  }
  @media (max-width: 767px) {
    ${props => 
      props.reposition ? `
        order: 3; 
        flex-basis: 100%; 
        margin-top: 21px;
      ` : null
    }
  }
`;

const HeaderLink = styled(Link)`
  color: white;
  padding-left: 8px;
  padding-right: 8px;
  ${props => props.location.pathname === props.to ? 'color: white;' : 'color: #959CAA;'}
`;

const MobileHidden = styled.span`
  @media (max-width: 767px) {
    display: none;
  }
`;

const ExternalLink = styled.a`
  color: #959CAA;
`;

const Header = (props) => {
  
  const primaryHeader = props.location.pathname === '/' || props.location.pathname === '/stories' || props.location.pathname === '/engineering' || props.location.pathname === '/company' || props.location.pathname === '/product';

  let header;
  if (primaryHeader) {
    header = (
      <HeaderContainer>
        <HeaderWrapper>
          <HeaderItem>
            <Link to={'/'} style={{display: 'flex'}}>
              <svg style={{height: 26, width: 26, fill: '#FFF'}}>
                <use xlinkHref={`#${Icon.id}`} />
              </svg>
            </Link>
          </HeaderItem>
          <HeaderItem
            position='middle'
            reposition
          >
            <HeaderLink location={props.location} to={'/'}>All</HeaderLink>
            {props.categories.map((category) => (
              <HeaderLink key={category.node.name} location={props.location} to={`/${category.node.name.toLowerCase()}`}>{category.node.name}</HeaderLink>
            ))}
          </HeaderItem>
          <HeaderItem
            position='end'
          >
            <ExternalLink href={'https://www.helpfulpeeps.com/signup'}>Join the community</ExternalLink>
          </HeaderItem>
        </HeaderWrapper>
      </HeaderContainer>
    )
  } else {
    header = (
      <HeaderContainer>
        <HeaderWrapper>
          <HeaderItem>
            <HeaderLink location={props.location} to={'/'}>&larr; Back<MobileHidden> to Helpfulpeeps Blog</MobileHidden></HeaderLink>
          </HeaderItem>
          <HeaderItem
            position='middle'
            notFull
          >
            <Link to={'/'} style={{display: 'flex'}}>
              <svg style={{height: 26, width: 26, fill: '#FFF'}}>
                <use xlinkHref={`#${Icon.id}`} />
              </svg>
            </Link>
          </HeaderItem>
          <HeaderItem
            position='end'
          >
            <ExternalLink href={'https://www.helpfulpeeps.com/signup'}>Join the community</ExternalLink>
          </HeaderItem>
        </HeaderWrapper>
      </HeaderContainer>
    )
  }

  return (
    header
  );
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.js